import md5 from '../../libs/md5.js'
export default class {
  async updateUser(){
    const input = JSON.parse(JSON.stringify(this.user));
    input.loginPwd = md5( input.loginPwd)
    const res = await this.http({cmd:'user/updateUser',input})
  }
  updateUserInfo(){
    const userInfo = JSON.parse(localStorage.users);
    this.user.userId = userInfo.userId;
    this.user.loginPwd = userInfo.loginPwd;
  }
  toggleDialog(){
   this.dialog = !this.dialog;
  }
  logout() {
    window.sessionStorage.removeItem('sessionId');
    window.sessionStorage.removeItem('userId');
    window.sessionStorage.removeItem('app.tabs');
    window.sessionStorage.removeItem('headIcon');
    window.sessionStorage.removeItem('realName');
    window.sessionStorage.removeItem('users');
    window.localStorage.removeItem('sessionId');
    window.localStorage.removeItem('userId');
    window.localStorage.removeItem('app.tabs');
    window.localStorage.removeItem('headIcon');
    window.localStorage.removeItem('realName');
    window.localStorage.removeItem('users');
    window.location.replace(window.location.href.split('/#/')[0] + '/login.html');
  }
}
